module.exports = __webpack_public_path__ + "media/svg-new/avatar-9 1-10034405.svg";